import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["disabled", "data-hotkey"];
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HotkeyKeys = _resolveComponent("HotkeyKeys");
    const _directive_i18n = _resolveDirective("i18n");
    return _withDirectives((_openBlock(), _createElementBlock("button", {
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click'))),
        class: _normalizeClass(["btn", _ctx.outerClass]),
        disabled: _ctx.isDisabled,
        "data-hotkey": _ctx.hotkey
    }, [
        (_ctx.hasIcon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["icon", _ctx.iconClass]),
                "data-test": "icon"
            }, null, 2))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.buttonText), 1)),
        (_ctx.hotkey !== undefined)
            ? (_openBlock(), _createBlock(_component_HotkeyKeys, {
                key: 2,
                action: _ctx.hotkey
            }, null, 8, ["action"]))
            : _createCommentVNode("", true)
    ], 10, _hoisted_1)), [
        [_directive_i18n]
    ]);
}
